import { computed, ref } from "vue";
import * as Sentry from "@sentry/vue";
import amenitiesService from "@/services/amenities";
import { AMENITIES_CATEGORIES, AMENITIES_GRANULARITIES } from "@/constants";

const amenitiesList = ref([]);

export function useAmenities() {
  if (amenitiesList.value.length === 0) {
    amenitiesService
      .getAmenities()
      .then((response) => {
        amenitiesList.value = response.data.data;
        amenitiesList.value.forEach((amenity) => {
          amenity.amenity_id = amenity.id;
        });
      })
      .catch((error) => {
        Sentry.captureException(error, {
          tags: {
            troubleshooting_note:
              "Failed to load amenities from amenities service",
          },
        });
      });
  }

  const filterAmenities = (category, granularity_level) => {
    return amenitiesList.value.filter(
      (amenity) =>
        amenity.category === category &&
        amenity.granularity_level === granularity_level
    );
  };

  const getHousingUnitAmenities = computed(() => {
    let new_amenities = filterAmenities(
      AMENITIES_CATEGORIES.AMENITIES,
      AMENITIES_GRANULARITIES.UNIT_LEVEL
    );
    new_amenities.splice(1, 0, {
      id: null,
      category: AMENITIES_CATEGORIES.ROUTINE_CLEANING,
      title: null,
      description: null,
      created_at: null,
    });
    new_amenities.splice(3, 0, {
      id: null,
      category: AMENITIES_CATEGORIES.ROUTINE_LAUNDRY_SERVICE,
      title: null,
      description: null,
      created_at: null,
    });
    return new_amenities;
  });

  const getHousingAmenitiesRoomUnit = computed(() => {
    let new_amenities = _.cloneDeep(
      amenitiesList.value.filter(
        (amenity) =>
          (amenity.category === AMENITIES_CATEGORIES.AMENITIES ||
            amenity.category === AMENITIES_CATEGORIES.SAFETY) &&
          amenity.granularity_level === AMENITIES_GRANULARITIES.ROOM_LEVEL
      )
    );
    new_amenities.map((amenity) => {
      amenity.checked = false;
      amenity.id = null;
      return amenity;
    });
    return _.cloneDeep(new_amenities);
  });

  return {
    filterAmenities,
    getHousingUnitAmenities,
    getHousingAmenitiesRoomUnit,
  };
}
